{
  "version": 1,
  "asset_id": "b44ce12a-45c4-4ab0-ba9d-fe73e64883b0",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/b44ce12a-45c4-4ab0-ba9d-fe73e64883b0/clip-img_2109-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/b44ce12a-45c4-4ab0-ba9d-fe73e64883b0/clip-img_2109-poster-sm.webp",
  "original_filename": "clip-img_2109-poster-sm.webp",
  "size": 12146,
  "content_type": "image/webp",
  "created_at": "2026-08-01T21:10:28Z"
}
